import { CustomDialog } from './custom-dialog';

export default CustomDialog;
